import { RefObject, useEffect, useState } from 'react';

export function useScrollState(ref: RefObject<HTMLElement | null>) {
  const [hasPreviousContent, setHasPreviousContent] = useState(false);
  const [hasMoreContent, setHasMoreContent] = useState(false);
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const scrollElement = ref.current;

    function updateScrollState() {
      const { scrollTop, scrollHeight, clientHeight } = scrollElement;
      setHasPreviousContent(scrollTop > 0);
      setHasMoreContent(scrollHeight > scrollTop + clientHeight + 1);
    }

    updateScrollState();
    scrollElement.addEventListener('scroll', updateScrollState);

    const resizeObserver = new ResizeObserver(updateScrollState);
    resizeObserver.observe(scrollElement);

    return () => {
      scrollElement.removeEventListener('scroll', updateScrollState);
      resizeObserver.disconnect();
    };
  }, [ref]);

  return {
    hasPreviousContent,
    hasMoreContent,
  };
}
